import { useQueryParams } from 'packages/common-frontend/hooks/useQueryParams';

export const creditFacilityIdQueryParam = 'creditFacility';

// @jendevelops TODO: consolidate across portfolio to use single custom hook
export const useCreditFacilityQueryParams = () => {
  const query = useQueryParams();
  const creditFacilityId = query.get(creditFacilityIdQueryParam);

  return { creditFacilityId };
};
